export function modifyRelForExternalLinks() {
    setTimeout(() => {
        document.querySelectorAll("a").forEach((link) => {
            const isExternal = !link.href.includes(window.location.host)
            // Skip adding noreferrer and noopener for links with data-follow attribute
            if (isExternal && !link.hasAttribute("data-follow")) {
                const relValues = link.rel.split(" ")
                if (!relValues.includes("noreferrer")) {
                    relValues.push("noreferrer")
                }
                if (!relValues.includes("noopener")) {
                    relValues.push("noopener")
                }
                link.rel = relValues.join(" ").trim()
            }
        })
    }, 1)
}
